import React from 'react'
import type { DefaultTheme } from 'styled-components'

import { RoundButton, TRoundButtonProps } from 'elements/button/RoundButton'
import { AbsoluteDiv, TAbsoluteDivProps } from 'elements/layout/AbsoluteDiv'
import type { TIconProps } from 'elements/media/Icon'

import { ICON } from 'config/icons'

export type TChevronProps = {
  icon?: TIconProps['name']
  color?: TIconProps['color']
  hoverColor?: keyof DefaultTheme['colors']
} & Pick<TAbsoluteDivProps, 'top' | 'right'> &
  Omit<TRoundButtonProps, 'icon'>

export const Chevron: TFCC<TChevronProps> = ({
  icon = ICON.CHEVRON_DOWN,
  color = 'black50',
  hoverColor = 'darkBlue',
  top = true,
  right = true,
  ...otherProps
}) => (
  <AbsoluteDiv top={top} right={right} p={{ xs: '3px', sm: '5px' }} zIndex="zIndex1" noPrint>
    <RoundButton color={color} hoverColor={hoverColor} icon={icon} {...otherProps} />
  </AbsoluteDiv>
)
